import { Volume2 } from 'lucide-react'
import type { ExerciseEditorProps } from '@/types'
import AudioPlayer from '@/components/common/AudioPlayer'
import OptionListEditor from '@/components/admin/OptionListEditor'

export default function ListeningEditor({ formData, setFormData, isViewMode }: ExerciseEditorProps) {
  const isValidUrl = (url: string) => {
    try {
      new URL(url)
      return true
    } catch {
      return false
    }
  }

  return (
    <div className="space-y-4">
      {/* Banner audio */}
      <div className="p-3 bg-[#0055A4]/5 border border-[#0055A4]/20 rounded-lg flex items-start gap-3">
        <Volume2 className="w-5 h-5 text-[#0055A4] mt-0.5 flex-shrink-0" />
        <p className="text-sm text-[#003d7a]">
          El estudiante escuchará el audio y luego seleccionará la respuesta correcta
          entre las opciones.
        </p>
      </div>

      {/* URL de Audio */}
      <div>
        <label htmlFor="listening-audio-url" className="block text-sm font-medium text-gray-700 mb-1">
          URL del Audio <span className="text-red-500">*</span>
        </label>
        <input id="listening-audio-url" type="url" value={formData.audio_url}
          onChange={(e) => setFormData(prev => ({ ...prev, audio_url: e.target.value }))}
          placeholder="https://... (MP3, WAV, OGG)"
          className="w-full px-3 py-2 border-2 border-[#0055A4]/30 rounded-lg focus:ring-2 focus:ring-[#0055A4] focus:border-[#0055A4] bg-[#0055A4]/10 disabled:bg-gray-100 disabled:cursor-not-allowed"
          required
          disabled={isViewMode}
        />
      </div>

      {/* Preview del audio */}
      {formData.audio_url && isValidUrl(formData.audio_url) && (
        <div className="p-4 bg-[#0055A4]/5 border border-[#0055A4]/10 rounded-lg">
          <p className="text-xs font-medium text-[#0055A4] mb-2">Vista previa del audio:</p>
          <AudioPlayer src={formData.audio_url} className="w-full" />
        </div>
      )}

      {/* Pregunta */}
      <div>
        <label htmlFor="listening-question" className="block text-sm font-medium text-gray-700 mb-1">
          Pregunta (después de escuchar)
        </label>
        <textarea id="listening-question" value={formData.question}
          onChange={(e) => setFormData(prev => ({ ...prev, question: e.target.value }))}
          placeholder="¿Qué dijo la persona en el audio?"
          rows={2}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#0055A4] focus:border-[#0055A4] disabled:bg-gray-100 disabled:cursor-not-allowed"
          required
          disabled={isViewMode}
        />
      </div>

      <OptionListEditor formData={formData} setFormData={setFormData} isViewMode={isViewMode} />
    </div>
  )
}
